import React, { ReactNode } from 'react';
import { ServicesContext, Services } from './services-context';

/**
 * Props for ServicesProvider
 */
interface ServicesProviderProps {
  children: ReactNode;
  accountService: Services['accountService'];
  apiClientService: Services['apiClientService'];
  deadLetterService: Services['deadLetterService'];
}

/**
 * ServicesProvider component
 * Provides application services to child components
 */
export const ServicesProvider: React.FC<ServicesProviderProps> = ({
  children,
  accountService,
  apiClientService,
  deadLetterService,
}) => {
  const services: Services = {
    accountService,
    apiClientService,
    deadLetterService,
  };

  return <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>;
};
